import { EMPTY_STRING } from '../../../constants/common'
import {
  getRequestPhaseStatus,
  getRequestPhaseStatusText,
} from '../Request.utils'

export function getRequestPhaseAsyncMultiValuedListItemStatusText({
  progress,
  t,
}) {
  const status = getRequestPhaseStatus(progress)

  return (
    t(getRequestPhaseStatusText(status)) +
    (Number.isSafeInteger(progress) ? ` (${progress}%)` : EMPTY_STRING)
  )
}
